import React from "react";
import {STEPS} from "../../../../../constants";

import {getLanguageScope} from '../../../../../helpers'
const _i18n = getLanguageScope('app_navigation');

import {Grid, Button, Message, Form} from 'semantic-ui-react'

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.onBack = this.onBack.bind(this);
  }

  componentDidUpdate(){
    const {submitValidator} = this.props;

    submitValidator && submitValidator()
  }

  onBack(){
    const {completeSession, changeStep, onBackCustom} = this.props;

    completeSession();

    if(onBackCustom && _.isFunction(onBackCustom)) return onBackCustom();

    return changeStep(STEPS.PRODUCTS);
  }

  render(){

    const {onSubmit, showSubmit, disabledSubmit, showError, messageError} = this.props;

    let submitView = null;
    if(showSubmit){
      submitView = (
          <Button floated='right' color='green' disabled={disabledSubmit} content={_i18n('submit')} onClick={() => onSubmit()}
                  icon='right arrow' labelPosition='right' />
      )
    }

    return (
      <Grid.Row columns={3}>
        <Grid.Column>
          <Button floated='left' content={_i18n('back')} onClick={this.onBack} icon='left arrow' labelPosition='left' />
        </Grid.Column>
        <Grid.Column>
          <Form>
            <Message visible={showError} error header={messageError}/>
          </Form>
        </Grid.Column>
        <Grid.Column>
          {submitView}
        </Grid.Column>
      </Grid.Row>
    )
  }
}

export default Navigation


// WEBPACK FOOTER //
// ./src/components/Applications/shared/Navigation/components/NavigationView.js